import { render, staticRenderFns } from "./OcorrenciasProcessoTermo.vue?vue&type=template&id=b6854412"
import script from "./OcorrenciasProcessoTermo.vue?vue&type=script&lang=js"
export * from "./OcorrenciasProcessoTermo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports